import { Component } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { AlertService } from "./share/service/alert.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html"
	// styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	constructor(
		private swUpdate: SwUpdate,
		private alertService: AlertService,
		private translate: TranslateService
	) {
		// Add available languages for translation
		this.translate.addLangs(["en", "bm"]);
		this.translate.setDefaultLang("en");
		const browserLang = this.translate.getBrowserLang();
		this.translate.use(browserLang.match(/en|bm/) ? browserLang : "en");

		// Check for updates if in production mode
		if (environment.production) {
			// this.checkForUpdates();
		}
	}

	private checkForUpdates(): void {
		// Ensure service worker is enabled before checking for updates
		if (this.swUpdate.isEnabled) {
			// Check for update in the background
			this.swUpdate
				.checkForUpdate()
				.then(() => {
					console.log("Checked for updates.");
				})
				.catch((error) => {
					console.error("Error checking for updates:", error);
				});

			// No `available` observable, so we check update manually
			setInterval(() => {
				this.swUpdate
					.checkForUpdate()
					.then(() => {
						console.log("Checked for updates again.");
					})
					.catch((error) => {
						console.error("Error checking for updates on interval:", error);
					});
			}, 10000); // Check for updates every 10 seconds (for demonstration)

			// The best practice here would be to notify users about a new update after `checkForUpdate`
			// You could store a flag in your app, or use a cache to check if the new version is loaded.

			this.alertService.openSnackBar(
				"A newer version is now available. Refresh the page now to update the cache"
			);

			// Optionally reload after a timeout for demonstration purposes
			setTimeout(() => {
				location.reload();
			}, 5000); // Automatically reload after 5 seconds (example)
		}
	}
}
